import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/domium-ia`;

export const iaApi = (getAuthHeader) => {
  const h = () => ({ headers: getAuthHeader() });
  return {
    classement: () => axios.get(`${API}/classement-coopers`, h()).then((r) => r.data.classement),
    exportXlsx: (q) => axios.get(`${API}/export.xlsx`, { ...h(), params: { q }, responseType: 'blob' }).then((r) => r.data),
    rappelEcheance: (id) => axios.post(`${API}/sessions/${id}/rappel-echeance`, { origin: window.location.origin }, h()).then((r) => r.data),
    dashboard: () => axios.get(`${API}/dashboard`, h()).then((r) => r.data),
    list: () => axios.get(`${API}/sessions`, h()).then((r) => r.data.sessions),
    create: () => axios.post(`${API}/sessions`, {}, h()).then((r) => r.data),
    get: (id) => axios.get(`${API}/sessions/${id}`, h()).then((r) => r.data),
    remove: (id) => axios.delete(`${API}/sessions/${id}`, h()),
    analyse: (id, files) => {
      const form = new FormData();
      files.forEach((f) => form.append('files', f));
      return axios.post(`${API}/sessions/${id}/analyse`, form, h()).then((r) => r.data);
    },
    save: (id, body) => axios.put(`${API}/sessions/${id}`, body, h()).then((r) => r.data),
    generate: (id) => axios.post(`${API}/sessions/${id}/generate`, { origin: window.location.origin }, h()).then((r) => r.data),
    prepare: (id, kind) => axios.post(`${API}/sessions/${id}/prepare/${kind}`, {}, h()).then((r) => r.data),
    versionPdf: (id, vid) => axios.get(`${API}/sessions/${id}/versions/${vid}/pdf`, { ...h(), responseType: 'blob' }).then((r) => r.data),
    versionAction: (id, vid, action) => axios.post(`${API}/sessions/${id}/versions/${vid}/${action}`, {}, h()).then((r) => r.data),
    link: (id) => axios.post(`${API}/sessions/${id}/completion-link`, { origin: window.location.origin }, h()).then((r) => r.data),
    sendLink: (id, email) => axios.post(`${API}/sessions/${id}/completion-link/send`, { email, origin: window.location.origin }, h()).then((r) => r.data),
    relancer: (id, email) => axios.post(`${API}/sessions/${id}/completion-link/relancer`, { email, origin: window.location.origin }, h()).then((r) => r.data),
    reanalyse: (id) => axios.post(`${API}/sessions/${id}/reanalyse`, {}, h()).then((r) => r.data),
    fileBlob: (id, fid) => axios.get(`${API}/sessions/${id}/fichiers/${fid}`, { ...h(), responseType: 'blob' }).then((r) => r.data),
    deleteFile: (id, fid) => axios.delete(`${API}/sessions/${id}/fichiers/${fid}`, h()).then((r) => r.data),
    devisEmail: (id) => axios.get(`${API}/sessions/${id}/devis-email`, h()).then((r) => r.data),
    sendDevisEmail: (id, body) => axios.post(`${API}/sessions/${id}/devis-email`, { ...body, origin: window.location.origin }, h()).then((r) => r.data),
  };
};

export const errMsg = (err, fallback) => {
  const d = err?.response?.data?.detail;
  return typeof d === 'string' ? d : fallback;
};

export const STATUS_LABELS = {
  NOUVEAU: { label: 'Nouveau', cls: 'bg-slate-200 text-slate-700' },
  ANALYZED: { label: 'Analysé', cls: 'bg-violet-600 text-white' },
  DEVIS_GENERATED: { label: 'Devis généré', cls: 'bg-emerald-600 text-white' },
};

export const SIGNATURE_LABELS = {
  non_envoye: { label: 'Devis non envoyé', cls: 'bg-slate-100 text-slate-600' },
  envoye: { label: 'En attente', cls: 'bg-amber-100 text-amber-800' },
  ouvert: { label: 'Ouvert', cls: 'bg-sky-100 text-sky-800' },
  signe: { label: 'Signé', cls: 'bg-emerald-100 text-emerald-800' },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—');

export const openBlob = (blob, type) => {
  const url = URL.createObjectURL(type ? new Blob([blob], { type }) : blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 300000);
};

export const fmtEUR = (v) => (v == null || v === '' ? '—' : `${Number(v).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`);
